import OfflineCourseMain from "../components/Course/OfflineCourseMain"

const Course = () => {
  return (
    <>
    <OfflineCourseMain/>
    </>
  )
}

export default Course